<template>
  <div class="password-input">
    <input
        autocomplete="new-password"
        :placeholder="placeholder"
        :type="showPassword ? 'text' : 'password'"
        v-model="inputValue"
        @keydown="inputSpace($event)"
        @keyup="inputSpace($event)"
        @input="$emit('input', $event.target.value);inputSpace($event)"
    />
    <span v-if="showPassword" class="show-password-icon" @click.stop="changeEye">
      <img :src="`${$g.imgPrefix}/img/login/eye@2x.webp`"/>
    </span>
    <span v-else class="show-password-icon" @click.stop="changeEye">
      <img :src="`${$g.imgPrefix}/img/login/closeEye.svg`"/>
    </span>
  </div>
</template>

<script>
export default {
  name: "passwordInput",
  props: {
    value: String,
    placeholder:String
  },
  data() {
    return {
      inputValue: '',
      showPassword: false
    }
  },
  watch:{
    value:{
      handler(newVal){
        this.inputValue = newVal;
      },
      immediate:true
    }
  },
  methods:{
    changeEye(){
      this.showPassword = !this.showPassword;
    },
    inputSpace(e){
      this.inputValue = e.target.value.trim();
    }
  }
}
</script>

<style lang="scss" scoped>
.password-input {
  position: relative;
  input{
    width: 100%;
    padding:0 15px;
    line-height: 48px;
    height: 48px;
    border: 2px solid rgba(91, 193, 127, 0.5);
    background: #fff;
    box-shadow: 40px 40px 60px 0 rgba(230, 234, 228, 0.3);
    border-radius: 11px;
    &::placeholder{
      color: #CACDD4;
    }
  }

  .show-password-icon {
    position: absolute;
    top: 0;
    right: 16px;
    bottom: 0;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img{
      width: 100%;
      height: auto;
    }
  }
}
</style>